/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toDepartmentProps } from './translator/department'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchDepartment, GetDepartment } from '@/infrastructure/network/Monitaro/requests/department'

export default class Department extends MonitaroGatewayBase {
  async FetchDepartment(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDepartment(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.departments.map((prop) => toDepartmentProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetDepartment(id: string) {
    const { department } = await this.apiClient.request(new GetDepartment(id))
    return toDepartmentProps(department)
  }
}
